import type Phaser from "phaser";

/**
 * "Снаряд перформанса" — летит от атакующей пары к защищающейся.
 * Спрайт с подменой текстур fx_perform_1/2 для эффекта пульсации.
 */
export default class Projectile {
  public sprite: Phaser.GameObjects.Sprite;

  constructor(
    private scene: Phaser.Scene,
    x: number,
    y: number,
  ) {
    this.sprite = scene.add.sprite(x, y, "fx_perform_1").setOrigin(0.5, 0.5);
    this.sprite.setDepth(10);
  }

  /** Полёт к (tx, ty) c пульсацией кадров. Возвращает Promise по приземлению. */
  fly(tx: number, ty: number, durationMs = 500): Promise<void> {
    return new Promise((resolve) => {
      let frame = 0;
      const t = this.scene.time.addEvent({
        delay: 80,
        loop: true,
        callback: () => {
          frame++;
          this.sprite.setTexture(frame % 2 === 0 ? "fx_perform_1" : "fx_perform_2");
        },
      });
      this.scene.tweens.add({
        targets: this.sprite,
        x: tx,
        y: ty,
        duration: durationMs,
        ease: "Quad.easeIn",
        onComplete: () => {
          t.remove();
          this.sprite.destroy();
          resolve();
        },
      });
    });
  }

  /** Облако сердечек/звёздочек на цели после попадания. */
  static playHitFx(scene: Phaser.Scene, x: number, y: number): Promise<void> {
    return new Promise((resolve) => {
      const s = scene.add.sprite(x, y, "fx_hit_1").setOrigin(0.5, 0.5);
      s.setDepth(11);
      let frame = 0;
      const t = scene.time.addEvent({
        delay: 100,
        loop: true,
        callback: () => {
          frame++;
          s.setTexture(frame % 2 === 0 ? "fx_hit_1" : "fx_hit_2");
        },
      });
      scene.time.delayedCall(500, () => {
        t.remove();
        s.destroy();
        resolve();
      });
    });
  }

  /** Розовое облачко появления для интро-эффекта. */
  static playPuff(scene: Phaser.Scene, x: number, y: number): Promise<void> {
    return new Promise((resolve) => {
      const s = scene.add.sprite(x, y, "fx_pokeball_puff").setOrigin(0.5, 1.0);
      s.setDepth(9);
      scene.tweens.add({
        targets: s,
        alpha: 0,
        scaleX: 1.4,
        scaleY: 1.4,
        duration: 500,
        onComplete: () => {
          s.destroy();
          resolve();
        },
      });
    });
  }
}
